/**
 * knb桥能力的封装
 */
import KNB from '@dp/knb';
import { dataURLToBlob } from 'blob-util';

const chooseImageByH5 = () => new Promise((resolve) => {
  try {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/png,image/jpg,image/jpeg';
    document.body.appendChild(fileInput);
    fileInput.click();
    fileInput.oninput = () => {
      resolve(Array.from(fileInput.files));
      document.body.removeChild(fileInput);
    };
  } catch (e) {
    resolve(null);
  }
});

// eslint-disable-next-line import/prefer-default-export
export const chooseImage = (sceneToken = 'dd-59c8022a27252643', count = 1) => new Promise((resolve) => {
  if (window.__wxjs_environment) {
    chooseImageByH5().then((fileListByH5) => {
      resolve(fileListByH5);
    });
    return;
  }
  KNB.chooseImage({
    sceneToken,
    source: '',
    returnType: 'base64',
    count,
    sizeType: ['original'],
    success: (res) => {
      const fileList = res.photoInfos.map((info) => {
        //  在开电宝中base64图片取的key值是localId，与knb文档中不符，经过亲测以当前为准
        const blob = dataURLToBlob(info.localId);
        blob.name = 'image.png';
        return blob;
      });
      resolve(fileList);
    },
    fail: async (reason) => {
      const { error } = reason;

      //  如果用knb选取失败，降级使用H5选取图片
      if (error === -1) {
        const fileListByH5 = await chooseImageByH5();
        resolve(fileListByH5);
      } else {
        resolve(null);
      }
    },
  });
});

export function openPage(url) {
  if (KNB.env.isTitans) {
    KNB.openPage({
      url,
    });
  } else if (KNB.env.isWX) {
    window.open(url, '_self');
  } else {
    window.open(url, '_blank');
  }
}

export function closePage() {
  if (KNB.env.isTitans) {
    KNB.closePage();
  } else {
    // window.open 的才可以close。
    window.close();
  }
}

export function getEnvDesc() {
  if (KNB.env.isTitans) {
    return '美团titans';
  } else if (KNB.env.isWX) {
    return '微信小程序wx';
  } else {
    return '其他';
  }
}
